import { all } from "redux-saga/effects";
import MyWork from "./mywork";

export const myWorkSaga = function* root() {
  yield all([MyWork()]);
};
